<div class="offset-1 offset-sm-1 offset-md-1 offset-lg-1">
    <form #form="ngForm">
        <div class="row col-md-12">
            <div class="col-md-6">
                <label for="medicalObservation" class="label-info">Observation médicale</label>
                <input (keydown)="activForm()" name="medicalObservation" id="medicalObservation"
                       [(ngModel)]="young.medicalObservation" type="text" class="form-control">
            </div>
            <div class="col-sm-6 d-flex align-items-center">
                <mat-slide-toggle (change)="activFormHandicap()" [checked]="checkActivHandicap()">Jeune en situation
                    d'handicap
                </mat-slide-toggle>
            </div>
        </div>
        <br>
        <div class="row col-md-12">
            <label>Niveau scolaire
            </label>
        </div>
        <div class="container-school-levels">
            <ng-container *ngIf="checkIfDataIsPresent()">
                <div class="row">
                    <div class="col-md-9">
                        <hr>
                        <app-school-level-input
                                [allSchoolLevels]="pSchoolLevelsAllValues"
                                [schoolLevel]="this.young.schoolLevel"
                                [schoolLevels]="pSchoolLevelsArray"
                                [schoolYearList]="schoolYearList"
                                (activForm)="parentChangeLevel()"
                        ></app-school-level-input>

                    </div>
                </div>
            </ng-container>
        </div>

        <div class="row">
            <div class="form-group col-10 col-lg-6">
                <app-select-multiple
                    [disabled]="
                        !scolarDifficultyForSelect ||
                        scolarDifficultyForSelect.length === 0
                    "
                    [group]="formGroup"
                    fcName="scolarDifficulty"
                    [items]="scolarDifficultyForSelect"
                    class="justify-content-center align-items-start"
                    textLabel="Difficulté(s) scolaire(s)"
                    (modelAttributeChange)="activForm()"
                />
            </div>
            @if (hasSchoolDifficulties) {
            <div class="form-group col-10 col-lg-6">
                <app-select-multiple
                    [disabled]="
                        !disciplineScolarDifficultyForSelect ||
                        disciplineScolarDifficultyForSelect.length === 0
                    "
                    [group]="formGroup"
                    fcName="disciplineScolarDifficulty"
                    [items]="disciplineScolarDifficultyForSelect"
                    class="justify-content-center align-items-start"
                    textLabel="Matière(s)"
                    [required]="true"
                    [error]="isInvalidDisciplineDIfficulteScolaire"
                    errorMsg="La matière est obligatoire"
                    (modelAttributeChange)="activForm()"
                />
            </div>
            }
        </div>
    </form>
</div>
<hr/>
<div class="row">
    <div class="offset-1 col-10 offset-sm-1 col-sm-10 offset-md-1 col-md-10 offset-lg-1 col-lg-10">
        <app-alert id="alert-step-1"></app-alert>
    </div>
</div>
<div class="row justify-content-center">
    <div class="offset-2 col-8 offset-sm-2 col-sm-8 offset-md-0 col-md-5 offset-lg-0 col-lg-5 mb-3">
        <button (click)="updateYoung()" class="btn btn-primary btn-lg btn-block" type="button" [disabled]="!formValid">
            Enregistrer
        </button>
    </div>
</div>



